import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';

import {
  InputField,
  CheckboxField,
  required,
  isUnique,
} from '../../../form';

class FeedMapping extends Component {
  isFieldUnique(value, allValues) {
    if (allValues && allValues.mapping) {
      const values = Object.entries(allValues.mapping).map(([_k, v]) => v);
      const validField = isUnique(value, values);
      if (validField && ![null, undefined, ''].includes(value)) return validField;
    }
  }

  hasUsedFields(value, allValues) {
    if (![null, undefined, ''].includes(value) && allValues && allValues.mapping) {
      const inputValues = value.split(',');
      const values = Object.entries(allValues.mapping).map(([_k, v]) => v);
      const usedFields = [];

      inputValues.forEach((v) => {
        if (values.includes(v)) { usedFields.push(v); }
      });
      return usedFields.length > 0 ? `Cannot include mapped fields in this input (${usedFields.join(', ')})` : undefined;
    }
  }

  render() {
    const { includesVideo } = this.props;

    return (
      <div>
        <h3>Field Mapping</h3>
        <p>Enter each XML tag from your feed that corresponds to the fields listed below (required fields are denoted with a *):</p>
        <Row>
          <Col md={12}>
            <Field
              type='text'
              name='root'
              label='Root*'
              validate={[required]}
              component={InputField}
              helpText='The XML tag that wraps each job'
            />
          </Col>
        </Row>
        <h3>General Fields</h3>
        <p>These tags are for job identification:</p>
        <Row>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[referencenumber]'
              label='Reference Number*'
              validate={[required, this.isFieldUnique]}
              component={InputField}
            />
          </Col>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[category]'
              label='Category'
              validate={[this.isFieldUnique]}
              component={InputField}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[company]'
              label='Company*'
              validate={[required, this.isFieldUnique]}
              component={InputField}
            />
          </Col>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[bid]'
              label='Bid'
              validate={[this.isFieldUnique]}
              component={InputField}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[url]'
              label='URL*'
              validate={[required, this.isFieldUnique]}
              component={InputField}
            />
          </Col>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[title]'
              label='Title*'
              validate={[required, this.isFieldUnique]}
              component={InputField}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[date]'
              label='Date*'
              validate={[required, this.isFieldUnique]}
              component={InputField}
            />
          </Col>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[description]'
              label='Description*'
              validate={[required, this.isFieldUnique]}
              component={InputField}
            />          
          </Col>
        </Row>
        <h3>Location Fields</h3>
        <p>
          These fields allow our search to match jobs based on location. 
          Map as many of the following fields as you can and 
          <strong> try to make sure you have filled out either the location field or city field</strong>
        </p>
        <Row>
          <Col md={12}>
            <Field
              type='text'
              name='mapping[location]'
              label='Location'
              infoText='Map this to a field that contains an aggregated location'
              validate={[this.isFieldUnique]}
              component={InputField}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[city]'
              label='City'
              validate={[this.isFieldUnique]}
              component={InputField}
            />          
          </Col>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[state]'
              label='State'
              validate={[this.isFieldUnique]}
              component={InputField}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[country]'
              label='Country'
              validate={[this.isFieldUnique]}
              component={InputField}
            />
          </Col>
          <Col md={6}>
            <Field
              type='text'
              name='mapping[postalcode]'
              label='Postal Code'
              validate={[this.isFieldUnique]}
              component={InputField}
            />
          </Col>
        </Row>
        <h3>Video Fields</h3>
        <Row>
          <Col md={12}>
            <Field
              type='checkbox'
              name='video'
              label='Jobs Have Video'
              singleLine
              component={CheckboxField}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Field
              type='text'
              name='mapping[videourl]'
              label={`Video URL${includesVideo ? '*' : ''}`}
              disabled={!includesVideo}
              validate={includesVideo ? [required, this.isFieldUnique] : []}
              component={InputField}
            />
          </Col>
        </Row>
        <h3>Ignored Fields</h3>
        <p>List below any XML tags in your feed that were not used in the above fields (separated by commas)</p>
        <Row>
          <Col md={12}>
            <Field
              type='text'
              textarea
              name='unmapped_list'
              label='Field List'
              validate={[this.hasUsedFields]}
              component={InputField}
            />
          </Col>
        </Row>
      </div>           
    );
  }
}

export default (FeedMapping);
